import React, { useEffect, useRef } from "react";
import { Text } from "../../Kit";
import { useOtp } from "../../../Store/modules/auth/otpSlice";

export type TimerProps = {
  duration: number;
};

export const Timer: React.FC<TimerProps> = (props) => {
  const { dispatchSetDuration, otpData } = useOtp();
  const { duration } = otpData || {};
  const interval = useRef<any>(null);

  useEffect(() => {
    if (duration > 0) {
      interval.current = setInterval(() => {
        dispatchSetDuration(duration - 1);
      }, 1000);
    }
    if (duration === 0) {
      clearInterval(interval.current);
      interval.current = null;
    }

    return () => {
      clearInterval(interval.current);
    };
  }, [dispatchSetDuration, duration]);

  return (
    <Text elementType="span" className="text-sm" translatable={false}>
      {Math.floor(duration / 60) < 10
        ? "0" + Math.floor(duration / 60)
        : Math.floor(duration / 60)}
      {":"}
      {duration % 60 < 10 ? "0" + (duration % 60) : duration % 60}
    </Text>
  );
};
